export interface Country {
  name: string;
  code: string;
  flag: string;
  subtitle: string;
  description: string;
  population: string;
  gdp: string;
  growthRate: string;
  currency: string;
  currencySymbol: string;
}

export interface PricingPlan {
  id: string;
  name: string;
  price: string;
  priceUSD: string;
  badgeColor: string;
  buttonColor: string;
  features: string[];
  hasThemeStudio: boolean;
  themeStudioUpgrade?: {
    price: string;
    message: string;
  };
  iframeUrl?: string;
}

export const staticData = {
  countries: [
    {
      name: 'Philippines',
      code: 'PH',
      flag: '🇵🇭',
      subtitle: 'A Dynamic and Fast-Growing Digital Economy',
      description: 'The Philippines, officially the Republic of the Philippines, is an archipelagic country in Southeast Asia. With over 7,000 islands, it offers a diverse and vibrant market for digital businesses.',
      population: '117 million',
      gdp: 'USD 435 billion',
      growthRate: '6.0%',
      currency: 'Philippine Peso',
      currencySymbol: '₱'
    },
    {
      name: 'Indonesia',
      code: 'ID',
      flag: '🇮🇩',
      subtitle: 'A Massive and Rapidly Growing Digital Market',
      description: 'Indonesia, officially the Republic of Indonesia, is the world\'s fourth most populous country, with a population of 280 million spread across more than 17,000 islands. In 2024, its nominal GDP reached USD 1.5 trillion, with a steady growth rate of 5.2%, reflecting strong economic momentum.',
      population: '280 million',
      gdp: 'USD 1.5 trillion',
      growthRate: '5.2%',
      currency: 'Indonesian Rupiah',
      currencySymbol: 'Rp'
    },
    {
      name: 'Vietnam',
      code: 'VN',
      flag: '🇻🇳',
      subtitle: 'An Emerging Digital Powerhouse in Southeast Asia',
      description: 'Vietnam, officially the Socialist Republic of Vietnam, is experiencing rapid digital transformation with a young, tech-savvy population and strong government support for digital initiatives.',
      population: '98 million',
      gdp: 'USD 450 billion',
      growthRate: '6.8%',
      currency: 'Vietnamese Dong',
      currencySymbol: '₫'
    },
    {
      name: 'India',
      code: 'IN',
      flag: '🇮🇳',
      subtitle: 'The World\'s Largest Democracy with Massive Digital Potential',
      description: 'India, officially the Republic of India, is the world\'s most populous democracy with over 1.4 billion people. It has one of the fastest-growing digital economies globally.',
      population: '1.4 billion',
      gdp: 'USD 3.7 trillion',
      growthRate: '7.2%',
      currency: 'Indian Rupee',
      currencySymbol: '₹'
    },
    {
      name: 'Bangladesh',
      code: 'BD',
      flag: '🇧🇩',
      subtitle: 'A Rapidly Modernizing Digital Market',
      description: 'Bangladesh, officially the People\'s Republic of Bangladesh, is experiencing significant digital growth with a large, young population and increasing internet penetration.',
      population: '170 million',
      gdp: 'USD 460 billion',
      growthRate: '6.0%',
      currency: 'Bangladeshi Taka',
      currencySymbol: '৳'
    },
    {
      name: 'Malaysia',
      code: 'MY',
      flag: '🇲🇾',
      subtitle: 'A High-Tech Hub in Southeast Asia',
      description: 'Malaysia is a modern, technologically advanced nation with strong digital infrastructure and a growing tech startup ecosystem.',
      population: '33 million',
      gdp: 'USD 430 billion',
      growthRate: '4.5%',
      currency: 'Malaysian Ringgit',
      currencySymbol: 'RM'
    },
    {
      name: 'Thailand',
      code: 'TH',
      flag: '🇹🇭',
      subtitle: 'A Balanced Blend of Tradition and Digital Innovation',
      description: 'Thailand, officially the Kingdom of Thailand, combines rich cultural heritage with modern digital transformation, offering unique opportunities for digital businesses.',
      population: '70 million',
      gdp: 'USD 500 billion',
      growthRate: '3.2%',
      currency: 'Thai Baht',
      currencySymbol: '฿'
    },
    {
      name: 'Mexico',
      code: 'MX',
      flag: '🇲🇽',
      subtitle: 'Latin America\'s Digital Gateway',
      description: 'Mexico, officially the United Mexican States, is Latin America\'s second-largest economy with a rapidly growing digital sector and strong trade connections.',
      population: '130 million',
      gdp: 'USD 1.7 trillion',
      growthRate: '3.1%',
      currency: 'Mexican Peso',
      currencySymbol: '$'
    },
    {
      name: 'Global',
      code: 'GL',
      flag: '🌍',
      subtitle: 'Worldwide Digital Opportunities',
      description: 'Expand your business globally with access to international markets, diverse customer bases, and worldwide digital infrastructure.',
      population: '8 billion+',
      gdp: 'USD 100+ trillion',
      growthRate: '3.0%',
      currency: 'US Dollar',
      currencySymbol: '$'
    }
  ],
};

export const motivationalMessages = {
  welcome: "Welcome to CSZGLOBAL! You're about to build something amazing! 🚀",
  countrySelected: "Great choice! This market has incredible potential for your business! 💪",
  planSelected: "Excellent! You've chosen a plan that will accelerate your success! ⚡",
  themeStudioUnlocked: "Congratulations! You now have access to our premium Theme Studio! 🎨",
  themeStudioUpgrade: "You're so close to unlocking Theme Studio! Just a small upgrade away! ✨",
  otpEntered: "Perfect! Your design is now saved and ready to go live! 🎉",
  businessSubmitted: "Amazing! Your business setup is complete! Welcome to the CSZGLOBAL family! 🌟",
  paymentCompleted: "Payment successful! Your platform is being prepared for launch! 🚀"
};

